import React from 'react';
import BasePipelineStepComponent from '../base_pipeline_step';

export default class RenameColumnStepComponent extends BasePipelineStepComponent {
    action_present = 'Rename';
    action_past = 'Renamed';

    icon = 'transformations-rename';

    updateStep(ev, step) {
        step.newName = ev.target.value;
    }

    renderHeader() {
        const {results} = this.state;
        return (
            <div className="pipeline-step-text pipeline-highlight">
                Rename <span className="column-highlight">{results.before}</span>
            </div>
        );
    }

    renderForm() {
        return (
            <form onSubmit={this.onSave}>
                <label className="label">
                    Name
                </label>
                <input
                    type="text"
                    value={this.state.tempStep.newName}
                    placeholder="Enter the new name"
                    onChange={this.onChange}
                    ref={(input) => {this.stepInput = input;}}
                />
            </form>
        );
    }

    renderValue() {
        const {results} = this.state;
        if (results.incomplete) {
            return this.renderHeader()
        }
        return (
            <div className="pipeline-step-text pipeline-highlight">
                Renamed <span className="column-highlight">{results.before}</span>{' to '}
                <span className="column-highlight">{results.after}</span>
            </div>
        );
    }
}
